<div (click)="handleSponsorClick(sponsor, 'homescreen_custom')">
    <a [href]="sponsor.url" target="_blank">
        <article class="bleachr-card" [appAspectRatio]="data">
            <div class="content-container">
                <img class="sp-image" [src]="sponsor.image_url" alt="sponsor image">
            </div>
        </article>
    </a>
</div>